import { LabelValueOption } from '@qred/components-library';
import { getCurrency } from '@qred/shared-component-library/src/currency';
import { numberFormatter } from '@qred/fe-cp-formatting-helpers';
import { removeWhitespace } from '~/helpers/formatters.helper';
import { CountryCode } from '~/enums';

export type TurnoverOption = LabelValueOption<string>;

const turnoverRangesNonEuro = [
  { min: 0, max: 10000 },
  { min: 10001, max: 20000 },
  { min: 20001, max: 30000 },
  { min: 30001, max: 50000 },
  { min: 50001, max: 75000 },
  { min: 75001, max: 125000 },
  { min: 125001, max: 250000 },
  { min: 250001, max: 1000000 },
  { min: 1000001, max: 50000000 },
  { min: 50000000 },
];

const turnoverRangesEuro = [
  { min: 0, max: 1000 },
  { min: 1001, max: 2000 },
  { min: 2001, max: 3000 },
  { min: 3001, max: 5000 },
  { min: 5001, max: 7500 },
  { min: 7501, max: 12500 },
  { min: 12501, max: 25000 },
  { min: 25001, max: 100000 },
  { min: 100001, max: 5000000 },
  { min: 5000000 },
];

export const formatTurnoverRange = (
  { min, max }: { min: number; max?: number },
  market: CountryCode
): TurnoverOption => {
  const formatter = numberFormatter(market);
  const label = max
    ? `${formatter(min)} - ${formatter(max)}`
    : `> ${formatter(min)}`;
  return { value: removeWhitespace(label), label };
};

export const getTurnoverOptions = (market: CountryCode): TurnoverOption[] => {
  const ranges =
    getCurrency(market).unit === '€'
      ? turnoverRangesEuro
      : turnoverRangesNonEuro;
  return ranges.map((range) => formatTurnoverRange(range, market));
};
